import React from 'react';

import styled from 'styled-components';

import PillSwitcher from 'components/lib/PillSwitcher';
import { ACTION_PLAN_SOURCE } from 'constants/actionPlan';
import { ActionPlanMetricsType } from 'types/actionPlans';

import { ACTION_PLAN_TAB_ALL, ACTION_PLAN_TAB_LABEL, ACTION_PLAN_TAB_ORDER, ActionPlanTab } from './constants';

const Container = styled.div`
  padding-bottom: 10px;
`;

const TabLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const TabCount = styled.span`
  color: var(--text-secondary);
  font-size: 10px;

  &.active {
    color: inherit;
  }
`;

const getTabCount = (metrics: ActionPlanMetricsType | undefined, tab: ActionPlanTab): number => {
  if (!metrics) {
    return 0;
  }

  switch (tab) {
    case ACTION_PLAN_SOURCE.AI_COMPETITIVE_INTELLIGENCE:
      return metrics.ai_competitive_intelligence;
    case ACTION_PLAN_SOURCE.USER_ADDED:
      return metrics.user_added;
    case ACTION_PLAN_SOURCE.ALERTS:
      return metrics.alerts;
    case ACTION_PLAN_TAB_ALL:
    default:
      return metrics.all;
  }
};

const getTabDataTestId = (tab: ActionPlanTab) =>
  `action-plans-tab-${tab === ACTION_PLAN_TAB_ALL ? 'all' : ACTION_PLAN_SOURCE[tab].toLowerCase().replace(/_/g, '-')}`;

type Props = {
  metrics: ActionPlanMetricsType | undefined;
  activeTab: ActionPlanTab;
  onChange: (tab: ActionPlanTab) => void;
};

const ActionPlansTabs = ({ metrics, activeTab, onChange }: Props) => {
  const tabItems = ACTION_PLAN_TAB_ORDER.map((tab) => ({
    key: tab,
    label: (
      <TabLabel>
        <span>{ACTION_PLAN_TAB_LABEL[tab]}</span>
        <TabCount className={tab === activeTab ? 'active' : ''}>{getTabCount(metrics, tab)}</TabCount>
      </TabLabel>
    ),
  }));

  return (
    <Container data-test-id="action-plans-tabs">
      <PillSwitcher items={tabItems} activeKey={activeTab} onChange={onChange} getItemTestId={getTabDataTestId} />
    </Container>
  );
};

export default ActionPlansTabs;
